(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["SLW-info"] && !window.DesignMode) return;
  try {
    

  window.addEventListener("load", function(){
    jQuery('.slw-info__title').on('click', function(){
      jQuery(this).toggleClass('open')
      jQuery(this).next().slideToggle();
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["SLW-pagetop"] && !window.DesignMode) return;
  try {
    

  window.addEventListener("load", function(){

    var btn    = jQuery('.slw-pagetop__btn');
    var startY = 122;
    var fade   = 600;
    var speed  = 400;
    
    jQuery(window).on('scroll', function(){
    	if (jQuery(this).scrollTop() > startY) {
    		btn.stop(false, false).addClass('is-visible');
    	} else {
    		btn.stop(false, false).removeClass('is-visible');
    	}
    });

    btn.on('click', function () {
    	jQuery('body,html').animate({
    		scrollTop: 0
    	}, speed);
    	return false;
    });


  });


  } catch(e) { console.error(e); }
})();

})();
